import { useSelector } from "react-redux";
import { selectCompanyGuid, selectCurrentToken, selectCurrentUserDisplayname } from "../../auth/authSlice";
import { useTranslation } from "react-i18next";
import Loading from "components/commons/Loading";
import PageLayout from "components/layout/PageLayout";
import UserCardLayout from "components/layout/UserCardLayout";
import { useGetUserInfoQuery } from "./api/userInfoApiSlice";
import { NavLink } from "react-router-dom";
import { useMemo } from "react";

const UserInfo = () => {

    const [t, i18n] = useTranslation(["global"])

    const {
        data: userInfo,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoQuery()

    const token = useSelector(selectCurrentToken)
    const currentCompany = useSelector(selectCompanyGuid)

    const currentEmployment = useMemo(() => {
        if (!userInfo) return
        return userInfo.employments.find(empl => empl.company.guid == currentCompany)
    }, [userInfo, currentCompany])


    let content;
    if (isLoading) {
        content = <Loading />
    } else if (isSuccess) {
        content = (

            <section className="userInfo">

                <div className="col mb-2 text-end">
                    <NavLink to={{ pathname: "/dashboard/userInfo/edit" }} className={`btn btn-light me-1`} ><i className="fa-solid fa-pen"></i> {t("action.edit")}</NavLink>
                </div>

                <UserCardLayout user={userInfo.user} employment={currentEmployment} />

                <div className="row mb-2">
                    <h3>System Info:</h3>
                    <div className="col">
                        <div className="card bg-dark opacity-50">
                            <div className="card-body">
                                <h5 className="card-title">GUID</h5>
                                {userInfo.user.guid}
                            </div>
                        </div>
                        <div className="card bg-dark opacity-50">
                            <div className="card-body">
                                <h5 className="card-title">JWT</h5>
                                {token}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return <PageLayout
        pageTitle={t("menu.my_profile")}
        bodyContent={content}
    />
}
export default UserInfo